import { render } from "./ContactStepOnboardingContent.vue?vue&type=template&id=0aed96e6"
import script from "./ContactStepOnboardingContent.vue?vue&type=script&lang=js"
export * from "./ContactStepOnboardingContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__